<template>
  <div class="common-priview-image">
    <img class="image" v-if="image" :src="image" alt="" @load="bindLoad" />
    <div v-else class="not-image">暂无图片</div>
    <van-loading
      class="image-loading"
      type="spinner"
      color="#333333"
      v-if="!loaded"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      image: '',
      loaded: false
    }
  },
  created() {
    this.image = decodeURIComponent(this.$route.query.imageUrl || '')
  },
  methods: {
    bindLoad() {
      this.loaded = true
    }
  }
}
</script>
<style lang="scss" scoped>
.common-priview-image {
  min-height: 100vh;
  .image {
    width: 100%;
    height: auto;
  }
  .not-image {
    margin-top: 100px;
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
  .image-loading {
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    z-index: 9;
  }
}
</style>
